import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { Provider } from "react-redux";
import store from "./redux/Store";
import ThemeSelector from "./ThemeSelector";
import { SnackbarProvider } from "notistack";
import { SocketProvider } from "./context/socketContext";
import host from "./redux/actions/host";
import matomo from "./context/matomo";
import { MatomoProvider } from "@datapunt/matomo-tracker-react";

ReactDOM.render(
  <React.StrictMode>
    <MatomoProvider value={matomo}>
      <Provider store={store}>
        <SocketProvider url={host}>
          <ThemeSelector>
            <SnackbarProvider maxSnack={3}>
              <App />
            </SnackbarProvider>
          </ThemeSelector>
        </SocketProvider>
      </Provider>
    </MatomoProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
